import { archiverUrl, fetchWithAuthorization } from '../../helpers/utils';

const TempDbApi = {
    fetchSpaceTime: (timeRangeQS: string, instanceId: number): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl()}/tempdb/space/time?${timeRangeQS}&id=${instanceId}`),
    fetchUsageSession: (timeRangeQS: string, instanceId: number): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl()}/tempdb/usage/session?${timeRangeQS}&id=${instanceId}`),
};

export default TempDbApi;
